module.exports = __webpack_public_path__ + "static/media/Online Store 4.92ad84c8.png";